<molecule-input-wrapper
    [formInputData]="formInputData"
    [formDisplayMode]="formDisplayMode"
    [formSummaryMode]="formSummaryMode"
    [inputOnly]="inputOnly"
    [validationErrorMessage]="validationErrorMessage"
    [hideGuidanceText]="hideGuidanceText"
    [value]="value"
    [useDefaultSummary]="false"
>
    @if (fileIndex) {
        <wdx-document-info class="d-block mb-1 w-100" [fileIndex]="fileIndex">
            @if (!formInputData.isDisabled) {
                <atom-icon-button
                    class="ms-2"
                    size="sm"
                    icon="times"
                    (onClick)="onRemoveFile()"
                ></atom-icon-button>
            }
        </wdx-document-info>
    } @else {
        <ngx-dropzone
            #drop
            [accept]="acceptedFileTypes"
            [multiple]="false"
            [disableClick]="true"
            [disabled]="formInputData.isDisabled"
            (change)="onAddFiles($event)"
        >
            @if (
                !fileIndex ||
                (fileUploadPackage &&
                    fileUploadStatus !== FILE_UPLOAD_STATUS.Completed)
            ) {
                <ngx-dropzone-label>
                    @if (!fileUploadPackage) {
                        <div>
                            @if (!isAcceptedFileFormat) {
                                <div
                                    class="danger-text form-section__body__blurb sub-3"
                                >
                                    {{
                                        formInputData.guidanceText ||
                                            rejectedFileTypeMessage
                                    }}
                                </div>
                            }
                            <div class="text-center body-text-medium">
                                <div>Drag and drop your file here</div>
                                <div>or</div>
                            </div>
                            <div class="d-flex justify-content-center">
                                <atom-icon-button
                                    class="mx-1"
                                    icon="file-upload"
                                    (click)="drop.showFileSelector()"
                                ></atom-icon-button>
                            </div>
                        </div>
                    }
                    @if (
                        fileUploadPackage &&
                        fileUploadStatus !== FILE_UPLOAD_STATUS.Completed
                    ) {
                        <div class="uploader__content--progress m-2">
                            <div class="d-flex justify-content-between">
                                @if (
                                    fileUploadStatus !==
                                    FILE_UPLOAD_STATUS.Failed
                                ) {
                                    <span
                                        >Uploading:&nbsp;{{
                                            fileUploadPackage.file.name
                                        }}</span
                                    >
                                }
                                @if (
                                    fileUploadStatus ===
                                    FILE_UPLOAD_STATUS.Failed
                                ) {
                                    <div>
                                        Upload failed:&nbsp;{{
                                            fileUploadPackage.file.name
                                        }}
                                    </div>
                                }
                            </div>
                            @if (
                                fileUploadStatus | fn: statusStyling;
                                as barColor
                            ) {
                                <ngb-progressbar
                                    [type]="barColor"
                                    [textType]="barColor"
                                    [value]="fileUploadProgress"
                                ></ngb-progressbar>
                            }
                            @if (
                                fileUploadStatus === FILE_UPLOAD_STATUS.Failed
                            ) {
                                <div
                                    class="d-flex align-items-center justify-content-center mt-4"
                                >
                                    <button
                                        class="btn btn-ghost me-1"
                                        (click)="drop.showFileSelector()"
                                    >
                                        Retry
                                    </button>
                                    <button
                                        class="btn btn-ghost ms-1"
                                        (click)="onRemoveFile()"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            }
                        </div>
                    }
                </ngx-dropzone-label>
            }
        </ngx-dropzone>
    }
</molecule-input-wrapper>
